<template>
  <div>
    <div class="content content_middle">
      <p class="content_middle_title page_color_1C2438">营业执照</p>
      <ul>
        <li id="se_bg_pufa">
          <input
            id="uploaderInputSecond"
            class="input uploaderInputSecond"
            type="file"
            v-if="!isPc"
            accept="image/*"
            capture="camera"
            @change="uploadImage"
          />
          <img
            :src="businessLicenseImg"
            v-if="businessLicenseImg"
          />
          <i class="add_ico">+</i>
        </li>
        <p class="instruction" style="text-align: center;" v-if="isPc"> {{isPc ? '请在手机端拍照上传' : ''}}</p>
        <p class="instruction" v-else>
          上传要求：<br />
          1、上传完整、清晰、有效的营业执照原件<br />
          2、单张图片最大不超过5M
        </p>
        <div class="sel-date">
            <span>营业期限：</span>
            <van-field v-model="currentStartDate" @click="startPicker = true;" readonly placeholder="开始日期" />
            至
            <van-field v-model="currentEndDate" @click="endPicker = true;" readonly placeholder="结束日期" />
        </div>
        <van-popup v-model="startPicker" position="bottom">
          <van-datetime-picker
            type="date"
            title="选择年月日"
            v-model="defaultStartDate"
            :min-date="startMinDate"
            :max-date="startMaxDate"
            @confirm="startConfirm"
            @cancel="startPicker = false"
            :formatter="formatter"
          />
        </van-popup>

        <van-popup v-model="endPicker" position="bottom">
          <van-datetime-picker
            type="date"
            title="选择年月日"
            v-model="defaultEndDate"
            :min-date="endMinDate"
            :max-date="endMaxDate"
            @confirm="endConfirm"
            @cancel="endPicker = false"
            :formatter="formatter"
          />
        </van-popup>
      </ul>
      <Button
        :loading="Isloading"
        loadingText="提交中..."
        :text="draw"
        :type="danger"
        :disabled="disabled || Isloading"
        class="nextStep"
        v-if="!isPc"
        :click="submit"
      />
      <div class="tips">营业期限长期、永久默认截止时间为2399/12/31</div>
      <div class="loadingBox" v-if="IsloadingBox">
        <Loading accountFont="" color="#fff" type="spinner"></Loading>
      </div>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import { Toast } from 'vant';
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';
import { checkStatus } from '@/views/pages/commonPage/mixin';
import Loading from '@/components/Loading.vue';

export default {
  name: 'BusinessLicenseUpload',
  data() {
    return {
      businessLicenseImg: '',
      idFrontPic: '',
      danger: 'danger',
      draw: '下一步',
      Isloading: false,
      IsloadingBox: false,
      showContent: '',
      startPicker: false,
      endPicker: false,
      startMinDate: new Date(1949, 1, 1),
      startMaxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1),
      endMinDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1),
      endMaxDate: new Date(2399, 12, 31),
      currentStartDate: '',
      currentEndDate: '',
      defaultStartDate: new Date(),
      defaultEndDate: new Date(),
      isPc: false,
    };
  },
  components: {
    Button,
    ServerBank,
    Loading,
  },
  computed: {
    disabled() {
      return !((this.currentStartDate && this.currentEndDate && this.businessLicenseImg));
    },
  },
  mixins: [checkStatus],
  mounted() {
    const y = new Date().getFullYear();
    const m = new Date().getMonth() + 1;
    const d = new Date().getDate() - 1;
    console.log(y, m, d);
    console.log(new Date(y, m, d));
    // let t = '';
    // t = '2021年07月20日至期'
    // t = '2021年07月13日至'
    // t = '2021年06月30日至2041年06月29日'
    // t= '2019年05月051至0月'
    // t= '2019年01月18日至2049年01月17日'
    // t = '2016年05月03日至2036年05月02'
    // t = '2013年02月28日至长期'
    // t = '2011年09月20日至永久'
    this.yiLianIsUpload();
  },
  methods: {
    yiLianIsUpload() {
      const np = navigator.platform;
      if (np.indexOf('Win') === 0 || np.indexOf('Mac') === 0
      ) {
        this.isPc = true;
      }
    },
    startConfirm(time) {
      this.currentStartDate = this.getdateNoTime(time);
      this.startPicker = false;
    },
    endConfirm(time) {
      this.currentEndDate = this.getdateNoTime(time);
      this.endPicker = false;
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      }
      if (type === 'month') {
        return `${val}月`;
      }
      if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    getdateNoTime(date) {
      const now = new Date(date);
      const y = now.getFullYear();
      const m = now.getMonth() + 1;
      const d = now.getDate();
      return `${y}年${m < 10 ? `0${m}` : m}月${d < 10 ? `0${d}` : d}日`;
    },
    uploadImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.idFrontPic = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          self.businessLicenseImg = item.target.result; // 图片内容的base64编码
          this.upload();
        };
      }
    },

    validate_img(file) {
      if (!/.(jpg|png|jpeg)$/i.test(file.name)) {
        Toast('请上传正确格式的营业执照');
        return false;
      }
      if (file.size.toFixed(5) >= 5 * 1024 * 1024) {
        Toast('请上传小于5M的图片');
        return false;
      }
      return true;
    },

    // eslint-disable-next-line consistent-return
    upload() {
      if (!this.businessLicenseImg) {
        return Toast('请上传营业执照图片');
      }

      const form = new FormData();
      form.append('orderId', this.$router.currentRoute.query.orderId);
      form.append('licensePic', this.idFrontPic);
      this.IsloadingBox = true;
      this.$api.CommonForms.licenseOcr(form).then((res) => {
        if (res.success) {
          const reverse = res.data.operatingPeriod.split('至');
          this.IsloadingBox = false;
          if (reverse.length === 2 && reverse[1]) {
            this.currentStartDate = this.isDateType(reverse[0]);
            this.currentEndDate = this.isDateType(reverse[1]);
          } else if (reverse.length === 2 && !reverse[1]) {
            this.currentStartDate = this.isDateType(reverse[0]);
          } else if (reverse.length === 1) {
            this.currentStartDate = this.transDate(res.data.registeredDate);
            if (['永久', '长期'].includes(reverse[0])) {
              this.currentEndDate = '2399年12月31日';
            } else {
              this.currentEndDate = '';
            }
          }
        } else {
          this.IsloadingBox = false;
          Toast(res.returnMessage || '识别失败');
        }
      });
    },
    isDateType(date) {
      if (['永久', '长期'].includes(date)) {
        return '2399年12月31日';
      } if (date.length >= 9 && date.indexOf('年') > -1 && date.indexOf('月') > -1 && date.indexOf('日') > -1) {
        return date;
      }
      return '';
    },
    transDate(date) {
      const t = date.split('-');
      return `${t[0]}年${t[1]}月${t[2]}日`;
    },
    submit() {
      this.$api.CommonForms.saveLicenseOcr({
        orderId: this.orderId || localStorage.getItem('orderId'),
        operatingPeriod: `${this.currentStartDate}至${this.currentEndDate}`,
      }).then((res) => {
        if (res.success) {
          this.Isloading = false;
          this.$store.dispatch('otherPages/jumpCurrPageServer');
        } else {
          this.Isloading = false;
          Toast(res.returnMessage || '上传失败');
        }
      });
    },
  },
};
</script>
<style scoped>
/* 营业执照上传 */
body {
  background-color: #f8f8f9;
}

.fl {
  float: left;
}

.fr {
  float: right;
}
.sel-date {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 14px;
}
>>>.van-cell:after {
  border-bottom: 0 !important;
}
>>>.van-cell {
  width: 30%;
  padding: 10px 0;
  text-align: center;
}
>>>.van-field__control:read-only {
  text-align: center;
}
.content_middle {
  box-sizing: border-box;
  padding: 0 15px 15px 15px;
  background: #fff;
}

.content_middle_title {
  margin: 0;
  padding: 13px 0;
  font-size: 17px;
  text-align: left;
}

.content_middle ul {
  text-align: center;
  background: #fff;
}

.content_middle ul li {
  background: #999999;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  width: 227px;
  height: 149px;
  margin: 0 auto;
  overflow: hidden;
}

.content_middle ul li img {
  position: absolute;
  top: 0;
  left: 0;
  width: 227px;
  height: 149px;
}

.content_bottom {
  margin-top: 0.08rem;
  padding: 0 0.15rem;
}

.add_ico {
  font-family: -webkit-pictograph !important;
  font-style: initial !important;
  font-size: 4rem;
  font-weight: bold;
  color: #fff;
  margin-top: -0.8rem;
}

.btnBox {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0.2rem;
  margin-bottom: 0.35rem;
  padding: 0 15px;
}

.btn {
  display: block;
  width: 100%;
  height: 44px;
  padding: 0;
  color: #fff;
  font-size: 17px;
  line-height: 44px;
  text-align: center;
  background-image: linear-gradient(-180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 4px;
}

/* 文字颜色 */
.page_color_F65249 {
  color: #ff6538;
}

.page_color_A1A9B6 {
  color: #a1a9b6;
}

.page_color_A5ADB9 {
  color: #a5adb9;
}

.page_color_1C2438 {
  color: #1c2438;
}
.tips {
  display: flex;
  justify-content: left;
  font-size: 12px;
  color: red;
  text-align: left;
  padding: 10px 15px 0 15px;
}

/* input */
.input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.instruction {
  width: 227px;
  margin: 0 auto;
  padding: 16px;
  font-size: 12px;
  color: #838d9b;
  text-align: left;
}
.loadingBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
